<div class="container mx-auto mt-4">
  <div class="row justify-content-center">
    <div class="col-md-5 mb-3">
      <div class="card h-100 text-center option-card" routerLink="/radicar">
        <div class="card-body d-flex flex-column align-items-center justify-content-center">
          <h3 class="card-title">Radicar PQR</h3>
          <p class="card-text">Presenta una nueva peticion, queja o reclamo.</p>
          <button class="btn btn-primary btn-lg mt-auto">Radicar</button>
        </div>
      </div>
    </div>
    <div class="col-md-5 mb-3">
      <div class="card h-100 text-center option-card" routerLink="/consultar">
        <div class="card-body d-flex flex-column align-items-center justify-content-center">
          <h3 class="card-title">Consultar PQR</h3>
          <p class="card-text">Consulta el estado de tu peticion, queja o reclamo.</p>
          <button class="btn btn-outline-primary btn-lg mt-auto">Consultar</button>
        </div>
      </div>
    </div>
  </div>
</div>
